export default __webpack_public_path__ + "85acaab8c640472a7234e91977652316.jpg";